import React from 'react';
import { style, stylesheet } from 'typestyle';
import { LocalizedStrings } from '@src/utils/localizedStrings';
import {
  SearchMarkDef, SearchTheme, SearchEventHandlers, SearchUtilityInterface, SearchElementRef,
} from '../../types/Search';
import { ActiveMark } from './ActiveMark';
import { Mark } from '../../components/Mark';
import { SearchAndSelectBar } from '../../components/SearchAndSelectBar';

interface Props {
  theme: SearchTheme
  inputValue: string
  markDefs: SearchMarkDef[]
  handlers: SearchEventHandlers
  elementRefs: SearchElementRef
  formatExclusion: SearchUtilityInterface['parseExclusion']
  compact?: boolean
}

export function Bar({ inputValue, markDefs, handlers, elementRefs, formatExclusion, compact = false }: Props) {
  function renderActiveMarks(defs: SearchMarkDef[], appearance: 'light' | 'dark' = 'light') {
    return defs.map((m) => {
      const [val, isExclusion] = formatExclusion(m.text);
      const formatedMark = { ...m, text: val };
      return (
        <ActiveMark
          key={`${m.type} + ${m.text}`}
          isExclusion={isExclusion}
          onClose={() => handlers.onCloseMark(m)}
          appearance={appearance}
        >
          <Mark markDef={formatedMark} />
        </ActiveMark>
      );
    });
  }

  const selectedMarks = renderActiveMarks(markDefs, compact ? 'dark' : 'light');

  return (
    <>
      <SearchAndSelectBar
        handlers={{
          onText: (v) => handlers.onText(v),
          onCloseBar: () => handlers.onCloseBar(),
          onInputFocus: () => handlers.onInputFocus(),
        }}
        elementRefs={elementRefs}
        inputValue={inputValue}
        description={lang.searchDescription}
        layout='singleLine'
      >
        {compact ? null : selectedMarks}
      </SearchAndSelectBar>
      {compact && selectedMarks.length > 0 ? (
        <div className={sheet.selectedMarksClass}>{selectedMarks}</div>
      ) : null}
    </>
  );
}

const lang = LocalizedStrings({
  en: {
    searchDescription: 'Search by caption, hashtag or visual label',
  },
});

const sheet = stylesheet({
  selectedMarksClass: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 12,
    marginTop: 10,
    paddingLeft: 5,
    paddingRight: 5,
  }
});
